<script>
import { VueController } from '@/service/support/vuex-controller';
import vaultService from "@/service/vault-service";

export default VueController("PortalExternalLookup", {
	state: [
		"organization",
		"organizationId",
		"cognito",
		"user"
	],
	data() {
		return {
			loading: true,
			errorMessage: null
		};
	},
	mounted() {
		this.lookupPortal();
	},
	methods: {
		async lookupPortal() {
			const orgId = this.$route.params.orgid;
			const extSys = this.$route.query.ext_sys;
			const extId = this.$route.query.ext_id;
			
			// Validate parameters
			if (!extSys || !extId) {
				this.errorMessage = "Missing required parameters. Please provide ext_sys and ext_id query parameters.";
				this.loading = false;
				return;
			}
			
			try {
				// Call the Lambda to find the vault
				const vault = await vaultService.query("getVaultByExternalId", {
					org_id: orgId,
					external_system: extSys,
					external_id: extId
				});
				
				if (vault && vault.id) {
					// Redirect to the portal
					this.$router.replace({
						name: 'Portal',
						params: {
							orgid: vault.org_id || orgId,
							vaultid: vault.id,
							folderid: 'main'
						}
					});
				} else {
					this.errorMessage = "No portal found with the specified external ID.";
					this.loading = false;
				}
			} catch (err) {
				console.error("Error looking up portal by external ID:", err);
				this.errorMessage = err.message || "Failed to find portal with the specified external ID.";
				this.loading = false;
			}
		},
		goToPortals() {
			this.$router.push('/vaults');
		}
	}
});
</script>

<template>
	<div class="portal-lookup-container">
		<v-container class="fill-height" fluid>
			<v-row align="center" justify="center">
				<v-col cols="12" sm="8" md="6">
					<v-card class="elevation-4 pa-6">
						<v-card-text class="text-center">
							<div v-if="loading">
								<v-progress-circular
									indeterminate
									color="primary"
									size="64"
									class="mb-4"
								></v-progress-circular>
								<h2 class="text-h5 mb-2">Looking up portal...</h2>
								<p class="grey--text">
									Searching for portal with external ID
								</p>
							</div>
							
							<div v-else-if="errorMessage">
								<v-icon size="64" color="error" class="mb-4">mdi-alert-circle-outline</v-icon>
								<h2 class="text-h5 mb-2">Portal Not Found</h2>
								<p class="error--text mb-4">{{ errorMessage }}</p>
								<v-btn color="primary" @click="goToPortals">
									Go to All Portals
								</v-btn>
							</div>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<style scoped>
.portal-lookup-container {
	min-height: 100vh;
	background-color: #f5f5f5;
}
</style>
